// Generated by @orus.eu/design-tokens — do not edit by hand
import type { ConfigExtension } from 'tailwind-merge'

export const tailwindMergeConfig: ConfigExtension<string, string> = {
  override: {
    classGroups: {
      'font-family': [{ font: ['heading', 'body'] }],
      'font-size': [{ text: ['110', '100', '90', '80', '70', '60', '50', '40', '30', '20', '10', '120', '130', 'input'] }],
      'font-weight': [{ font: ['500', '400', '600'] }],
      'leading': [{ leading: ['10', '110', '100', '90', '80', '70', '60', '40', '30', '20', '50', '120', '130'] }],
      'tracking': [{ tracking: ['10', '30', '40', '20'] }],
    },
  },
  extend: {
    theme: {
      radius: ['10', '20', '30', '40', '50', '60', '70'],
      shadow: ['bottom-10', 'bottom-20', 'bottom-30', 'bottom-40', 'bottom-05', 'top-10', 'top-20', 'top-30', 'top-40', 'top-05'],
    },
  },
}
